import {stickyScroll} from './footer'
import {menuScroll} from './menus'

window.addEventListener('scroll', stickyScroll);
window.addEventListener('scroll', menuScroll);
